// extracted by mini-css-extract-plugin
module.exports = {"widget":"TrustPilotMicroReviewCount_widget__aq7yy"};